var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 47,
    viewBox: "0 0 31 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0297 46.1785C29.5334 46.1785 29.0372 45.7815 29.0372 45.2852L25.2654 -5.23574C25.1662 -7.12159 24.3722 -7.91564 24.0744 -7.91564C23.6774 -7.91564 22.9826 -7.12159 22.8833 -5.13649L20.2034 41.5135C20.0049 44.8882 18.3176 46.0793 17.0273 46.0793C15.7369 46.0793 14.0496 44.8882 13.8511 41.6128L10.0794 -5.43425C9.88086 -7.32011 9.18608 -8.11415 8.88831 -8.11415C8.49129 -8.11415 7.7965 -7.3201 7.69724 -5.335L4.81884 41.2158C4.62033 44.5905 2.93299 45.7815 1.64267 45.7815C0.352345 45.7815 -1.335 44.6897 -1.63276 41.4143L-6 -8.80894C-6 -9.30521 -5.60298 -9.80149 -5.1067 -9.80149C-4.51117 -9.90074 -4.01489 -9.50372 -4.01489 -8.90819L0.352345 41.315C0.550856 43.2009 1.24564 43.8957 1.54341 43.8957C1.94043 43.8957 2.63522 43.1016 2.73448 41.1165L5.61288 -5.43425C5.91065 -8.80894 7.49873 -10 8.88831 -10C10.1786 -10 11.866 -8.80894 12.0645 -5.53351L15.7369 41.6128C15.9354 43.4986 16.6302 44.2927 16.928 44.2927C17.325 44.2927 18.0198 43.4986 18.1191 41.5135L20.799 -5.13649C20.9975 -8.51117 22.6848 -9.70223 23.9751 -9.70223C25.2654 -9.70223 26.9528 -8.51117 27.1513 -5.23574L30.923 45.2852C31.0223 45.7815 30.6252 46.1785 30.0297 46.1785C30.129 46.1785 30.129 46.1785 30.0297 46.1785Z",
    fill: "#E9EBF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.b1fd61d254670a3bc4d70c8a93633fec.svg";
export { ForwardRef as ReactComponent };